const ROW_CLASS = 'grid grid-cols-[1fr_auto] items-baseline gap-4 text-sm';

const TOTAL_CLASS = 'mt-1 pt-2 font-semibold';

const rowClass = (isTotal, isSecondary) => [
    ROW_CLASS,
    isSecondary ? 'py-1' : 'py-2',
    isTotal ? TOTAL_CLASS : ''
].filter(Boolean).join(' ');

const valueClass = ({ isNegative, isSecondary }) => [
    'tabular-nums whitespace-nowrap',
    isNegative ? 'text-[#c1341a]' : '',
    !isNegative && isSecondary ? 'text-gray-500' : ''
].filter(Boolean).join(' ');

export default function LedgerRow({ label, hint, value, isTotal, isNegative, isSecondary }) {
    return (
        <div className={rowClass(isTotal, isSecondary)}>
            <span className={isSecondary ? 'text-gray-500' : 'text-[#1d1d1f]'}>
                {label}
                {hint ? <span className="text-gray-400"> {hint}</span> : null}
            </span>
            <span className={valueClass({ isNegative, isSecondary })}>{value}</span>
        </div>
    );
}
